import Image from 'next/image'
import logo from '../../../public/imgs/with_values_logo.svg'

export default function WithValuesLogo() {
    return(
        <>
            <Image src={logo} />
        </>
    );
}